import { Icon } from "@material-ui/core";
import React, { Fragment } from "react";

export default function RecursiveMenu({
  items,
  classes,
  parseTitle,
  level = 0,
}) {
  return (
    <ul
      className={level > 0 ? classes.cssSubmenu : classes.cssMenu}
      data-level={level}
    >
      {items.map((item, index) => (
        <li key={item.url || index} className={classes.cssMenuItem}>
          <a href={item.url} className={classes.cssMenuLink}>
            {parseTitle(item.title)}
            {item.submenu && (
              <Fragment>
                <Icon className={classes.iconOpen}>arrow_drop_up</Icon>
                <Icon className={classes.iconClose}>arrow_drop_down</Icon>
              </Fragment>
            )}
          </a>
          {item.submenu && item.submenu.length > 0 && (
            <RecursiveMenu
              items={item.submenu}
              classes={classes}
              parseTitle={parseTitle}
              level={level + 1}
            />
          )}
        </li>
      ))}
    </ul>
  );
}
